export const handleKeyDown = (e: React.KeyboardEvent): void => {
  // Prevent spacebar events from being captured by parent components
  if (
    e.key === ' ' ||
    e.code === 'Space' ||
    e.key === 'Backspace' ||
    e.key === 'Delete'
  ) {
    e.stopPropagation()
  }
}
